import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class OrderProblemReason extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1 className="text--xxl-title l-margin-bottom--xl">Order problem reason</h1>
				<table>
		<tbody><tr>
			<th>ID </th>
			<th>Description </th>
		</tr>
		<tr>
			<td> 6 </td>
			<td> Buyer did not respond to emails </td>
		</tr>
		<tr>
			<td> 7 </td>
			<td> Buyer email address bounced </td>
		</tr>
		<tr>
			<td> 8 </td>
			<td> Seller did not receive payment </td>
		</tr>
		<tr>
			<td> 9 </td>
			<td> Buyer found items elsewhere </td>
		</tr>
		<tr>
			<td> 10 </td>
			<td> Buyer no longer wants to purchase items </td>
		</tr>
		<tr>
			<td> 11 </td>
			<td> Buyer does not have enough funds to pay </td>
		</tr>
		<tr>
			<td> 12 </td>
			<td> Buyer did not comply with store policies </td>
		</tr>
		<tr>
			<td> 13 </td>
			<td> Buyer submitted a bogus order </td>
		</tr>
		<tr>
			<td> 16 </td>
			<td> Buyer demanded a lower price on items </td>
		</tr>
		<tr>
			<td> 57 </td>
			<td> Package returned with incorrect address </td>
		</tr>
		<tr>
			<td> 60 </td>
			<td> Seller did not have items after order was submitted </td>
		</tr>
		<tr>
			<td> 63 </td>
			<td> Buyer is underage </td>
		</tr>
		<tr>
			<td> 72 </td>
			<td> Buyer is no longer registered </td>
		</tr>
		<tr>
			<td> 97 </td>
			<td> Package cannot be delivered to buyer's address </td>
		</tr>
		<tr>
			<td> 100 </td>
			<td> Buyer did not pay for order </td>
		</tr>
		<tr>
			<td> 70 </td>
			<td> System Problem </td>
		</tr>
		<tr>
			<td> 107 </td>
			<td> Mutual agreement between buyer and seller to cancel </td>
		</tr>
	</tbody></table>
			</section>
		);
	}
}